import styled from 'styled-components';

export const StyledContainerPageError = styled.div`
  background-color: #F3F5F8;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  
  h2 {
    font-family: Poppins-Semi-Bold, sans-serif;
    font-size: 36px;
    color: #707070;
    margin-top: 5px;
    margin-bottom: -5px;
  }
  
  p {
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 25px;
    color: #8B8C99;
  }  
  
  .cockpit-load__icon {
    width: 128px;
    height: 128px;
    display: inline-block;
    stroke: #C5C6D0;
    stroke-width: 1px;
    stroke-dashoffset: 260px;
    stroke-dasharray: 260px;  
    
    * {
      fill: transparent;
    }
    
    .st0 {
      webkit-animation: cockpit-load-icon-circle 3s infinite;
      animation: 5000ms ease 0ms infinite normal none running cockpit-load-icon-circle;
    }
    
    @keyframes cockpit-load-icon-circle {
      0% {
        stroke-dashoffset: 260px;
        fill: transparent;
      }
      79% {
        stroke-dashoffset: 0;
        fill: transparent;
      }
      80% {
        stroke-dashoffset: 260px;
        fill: red;  
      }
      100% {
        stroke-dashoffset: 260px;
        fill: red;
      }
    }
  }
`;
